/**
 * Cosul Cosmeticos: costul de procesare si serviciile optionale, in tema.
 * Inlocuieste UpCart + Upcharge Fees.
 *
 * - taxa de procesare: obligatorie, se adauga singura cand cosul are produse,
 *   linia din cos e ascunsa vizual, clientul o vede ca rand informativ si
 *   o aproba cu o bifa inainte sa poata finaliza comanda
 * - servicii pe bifa (expediere prioritara): adauga / scot produsul,
 *   linia ramane ascunsa vizual
 * - propunere de produs: se adauga cu buton, ramane linie normala in cos
 *
 * Se sprijina doar pe Ajax Cart API si pe API-ul temei Minimog
 * (MinimogEvents, Shopify.onCartUpdate, MinimogTheme.Cart).
 */
(function () {
  'use strict';

  var ACK_KEY = 'ct_fee_ack';
  var busy = false;
  var busySince = 0;
  var feeFails = 0;
  var lastFeeTry = 0;

  /**
   * Daca o operatie ramane agatata (retea moarta, re-randare care nu se mai
   * termina), `busy` ar bloca pentru totdeauna readaugarea costului.
   * Dupa 12 secunde consideram operatia pierduta si mergem mai departe.
   */
  function locked() {
    if (!busy) return false;
    if (Date.now() - busySince > 12000) { busy = false; return false; }
    return true;
  }

  function lock() { busy = true; busySince = Date.now(); }

  function root() {
    return document.querySelector('[data-ct-extras]');
  }

  /**
   * Tema randeaza sertarul si pagina de cos in acelasi document, deci blocul
   * poate exista de mai multe ori. Starea se aplica pe toate, nu doar pe primul.
   */
  function allNodes() {
    return Array.prototype.map.call(
      document.querySelectorAll('[data-ct-extras]'),
      function (r) {
        return {
          root: r,
          upsell: r.querySelector('[data-ct-upsell]'),
          fee: r.querySelector('[data-ct-fee]'),
          addons: Array.prototype.slice.call(r.querySelectorAll('[data-ct-addon]'))
        };
      }
    );
  }

  function nodes() {
    return allNodes()[0] || null;
  }

  /** Variantele care nu se pun la socoteala cand decidem daca cosul are marfa. */
  function serviceVariantIds(n) {
    var ids = [];
    if (n.fee) ids.push(n.fee.getAttribute('data-variant'));
    n.addons.forEach(function (el) {
      ids.push(el.getAttribute('data-variant'));
    });
    return ids;
  }

  /** Produsele ale caror linii nu trebuie sa apara in lista din cos. */
  function hiddenProductIds(n) {
    var ids = [];
    if (n.fee) ids.push(n.fee.getAttribute('data-product'));
    n.addons.forEach(function (el) {
      ids.push(el.getAttribute('data-product'));
    });
    return ids.filter(Boolean);
  }

  /* ---------- acces la cos, cu o singura cerere la 800ms ---------- */

  var cartCache = null;
  var cartCacheAt = 0;
  var cartInFlight = null;
  var CART_TTL = 800;

  function getCart(force) {
    var now = Date.now();
    if (!force && cartCache && now - cartCacheAt < CART_TTL) {
      return Promise.resolve(cartCache);
    }
    if (cartInFlight) return cartInFlight;

    cartInFlight = fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        // Shopify serveste /cart.js si ca text/javascript, deci nu ne luam
        // dupa content-type; incercam sa citim JSON si prindem esecul.
        return r.text().then(function (t) { return JSON.parse(t); });
      })
      .then(function (cart) {
        cartCache = cart;
        cartCacheAt = Date.now();
        return cart;
      })
      .catch(function () {
        return cartCache;
      })
      .then(function (cart) {
        cartInFlight = null;
        return cart;
      });

    return cartInFlight;
  }

  function inCart(cart, variantId) {
    if (!cart || !cart.items) return null;
    return cart.items.filter(function (item) {
      return String(item.variant_id) === String(variantId);
    })[0];
  }

  /** Reincarca starea cosului si re-randeaza corpul sertarului prin tema. */
  function refresh() {
    cartCache = null;
    var Cart = window.MinimogTheme && window.MinimogTheme.Cart;
    if (!Cart) return getCart(true);
    return Cart.refreshCart()
      .then(function () { return Cart.renderNewCart(); })
      .then(function () {
        if (window.Shopify && window.Shopify.onCartUpdate) {
          return window.Shopify.onCartUpdate(Cart.cart, false);
        }
      })
      .then(function () { return Cart.cart || getCart(true); });
  }

  function addLine(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add.js ' + res.status);
      return res.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) throw new Error('change.js ' + res.status);
      return res.json();
    });
  }

  function hideServiceLines(n) {
    hiddenProductIds(n).forEach(function (pid) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.scd-item[data-product-id="' + pid + '"]'),
        function (line) { line.classList.add('ct-line-hidden'); }
      );
    });
  }

  function feeAcknowledged() {
    try { return window.localStorage.getItem(ACK_KEY) === '1'; } catch (e) { return false; }
  }

  function setFeeAcknowledged(on) {
    try { window.localStorage.setItem(ACK_KEY, on ? '1' : '0'); } catch (e) {}
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: { _taxa_procesare: on ? 'aprobata de client' : '' }
      })
    }).catch(function () {});
  }

  /* ---------- sincronizare ---------- */

  function sync(cart) {
    if (!cart || !cart.items) return;
    var list = allNodes();
    if (!list.length) return;
    list.forEach(function (n) { syncOne(n, cart); });
    paintCount(cart, serviceVariantIds(list[0]));
    paintCheckoutTotal();
    gateCheckout(list[0]);
  }

  /**
   * Counterul de pe iconita numara doar produsele reale. Tema scrie acolo
   * cart.item_count (cu tot cu taxa si servicii), asa ca il rescriem dupa
   * fiecare sincronizare; pulsul de mai jos prinde si rescrierile ei.
   */
  function paintCount(cart, services) {
    var qty = 0;
    cart.items.forEach(function (i) {
      if (services.indexOf(String(i.variant_id)) === -1) qty += i.quantity;
    });
    var v = String(qty);
    Array.prototype.forEach.call(document.querySelectorAll('.sf-cart-count'), function (el) {
      if (el.textContent !== v) el.textContent = v;
    });
  }

  function syncOne(n, cart) {
    var services = serviceVariantIds(n);
    var goods = cart.items.filter(function (item) {
      return services.indexOf(String(item.variant_id)) === -1;
    });

    n.root.hidden = goods.length === 0;
    hideServiceLines(n);

    // Cosul e gol de marfa: scoatem serviciile ramase agatate.
    if (goods.length === 0) {
      if (cart.items.length) dropOrphans(cart, services);
      return;
    }

    if (n.fee) {
      if (enforceFee(n, cart)) return;

      var feeLine = inCart(cart, n.fee.getAttribute('data-variant'));

      // Pretul afisat vine din cos, ca sa nu ramana in urma cand se schimba.
      if (feeLine) {
        var slot = n.fee.querySelector('.ct-fee__price');
        if (slot && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          try {
            slot.textContent = window.Shopify.formatMoney(feeLine.price, window.ctMoneyFormat || '{{amount_with_comma_separator}} lei');
          } catch (e) {}
        }
      }

      var ackNow = feeAcknowledged();
      n.fee.classList.toggle('is-ack', ackNow);
      n.fee.classList.toggle('is-pending', !ackNow);
      var ackBox = n.fee.querySelector('[data-ct-fee-ok]');
      if (ackBox) ackBox.checked = ackNow;
    }

    if (n.upsell) {
      var upId = n.upsell.getAttribute('data-variant');
      var added = !!inCart(cart, upId);
      // Daca produsul e deja in cos, propunerea nu mai are ce cauta in sertar.
      // Cand clientul il scoate, reapare.
      n.upsell.hidden = added;
      n.upsell.classList.toggle('is-added', added);
    }

    n.addons.forEach(function (el) {
      var box = el.querySelector('input[type="checkbox"]');
      if (box) box.checked = !!inCart(cart, el.getAttribute('data-variant'));
    });
  }

  /**
   * Costul de procesare e obligatoriu: daca lipseste il punem la loc, iar
   * daca a ajuns pe mai multe linii sau cu cantitate mai mare de 1, corectam.
   * Rezultatul garantat: exact o linie, cu cantitatea 1.
   *
   * Nu renuntam niciodata sa il readaugam. Daca am renunta, un client care
   * sterge linia o data ar ramane fara ea pentru tot restul vizitei. Doar
   * rarim incercarile cand nu reusesc, ca sa nu batem serverul degeaba.
   *
   * Intoarce true daca a pornit o corectie (deci starea afisata se
   * recalculeaza dupa ce se termina).
   */
  function enforceFee(n, cart) {
    if (locked()) return false;
    var feeVariant = n.fee.getAttribute('data-variant');
    var lines = cart.items.filter(function (i) {
      return String(i.variant_id) === String(feeVariant);
    });

    // Lipseste: o punem la loc, cu pauze crescatoare intre esecuri.
    if (lines.length === 0) {
      var pauza = feeFails === 0 ? 0 : Math.min(2500 * feeFails, 15000);
      if (Date.now() - lastFeeTry < pauza) return false;

      lock();
      feeFails++;
      lastFeeTry = Date.now();

      addLine(feeVariant)
        .then(function () { feeFails = 0; })
        .then(refresh)
        .then(sync)
        .catch(function (e) {
          console.warn('[ct-extras] costul de procesare nu s-a putut adauga:', e && e.message);
        })
        .then(function () { busy = false; });
      return true;
    }

    // Linia exista: incercarile pornesc de la zero data viitoare.
    feeFails = 0;

    // A ajuns pe mai multe linii: le pastram doar pe prima.
    if (lines.length > 1) {
      lock();
      var extra = lines.slice(1);
      var chain = Promise.resolve();
      extra.forEach(function (line) {
        chain = chain.then(function () { return changeLine(line.key, 0); });
      });
      chain
        .then(refresh)
        .then(sync)
        .catch(function (e) { console.warn('[ct-extras] curatare duplicate esuata', e); })
        .then(function () { busy = false; });
      return true;
    }

    // Cantitate mai mare de 1: o aducem la 1.
    if (lines[0].quantity !== 1) {
      lock();
      changeLine(lines[0].key, 1)
        .then(refresh)
        .then(sync)
        .catch(function (e) { console.warn('[ct-extras] corectie cantitate esuata', e); })
        .then(function () { busy = false; });
      return true;
    }

    return false;
  }

  /**
   * Butonul de finalizare ramane blocat pana cand clientul confirma
   * costul de procesare. Acordul pentru termeni se da in checkout, nu aici.
   */
  function checkoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.scd__checkout, .cart__submit')
    );
  }

  function gateCheckout(n) {
    var btns = checkoutButtons();
    if (!btns.length) return;

    if (!n.fee) {
      btns.forEach(function (btn) { btn.disabled = false; });
      Array.prototype.forEach.call(document.querySelectorAll('.ct-lock'), function (el) { el.hidden = true; });
      return;
    }

    var ok = feeAcknowledged();
    n.fee.classList.toggle('is-pending', !ok);

    btns.forEach(function (btn) {
      btn.disabled = !ok;
      var hint = btn.parentNode.querySelector('.ct-lock');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'ct-lock';
        hint.textContent = 'Confirmă costul de procesare ca să poți finaliza comanda.';
        btn.parentNode.insertBefore(hint, btn.nextSibling);
      }
      hint.hidden = ok;
    });
  }

  /**
   * Suma trece pe butonul de finalizare. Luam textul deja formatat de tema
   * din randul de subtotal (ascuns prin CSS), ca sa nu reinventam formatarea.
   */
  function paintCheckoutTotal() {
    var price = document.querySelector('.scd__subtotal-price') || document.querySelector('[data-cart-subtotal-price]');
    var total = price ? price.textContent.trim() : null;
    if (!total) return;
    checkoutButtons().forEach(function (btn) {
      var label = btn.querySelector('span:not(.ct-total)');
      if (!label) return;
      var slot = btn.querySelector('.ct-total');
      if (!slot) {
        slot = document.createElement('span');
        slot.className = 'ct-total';
        label.parentNode.insertBefore(slot, label.nextSibling);
      }
      slot.textContent = total;
    });
  }

  function dropOrphans(cart, serviceIds) {
    var orphan = cart.items.filter(function (item) {
      return serviceIds.indexOf(String(item.variant_id)) !== -1;
    })[0];
    if (!orphan || locked()) return;
    lock();
    changeLine(orphan.key, 0)
      .then(refresh)
      .then(sync)
      .catch(function (err) { console.warn('[ct-extras] curatare esuata', err); })
      .then(function () { busy = false; });
  }

  function toggle(variantId, wanted, host) {
    if (locked()) return;
    lock();
    if (host) host.classList.add('is-busy');

    var work = wanted
      ? addLine(variantId)
      : getCart(true).then(function (cart) {
          var line = inCart(cart, variantId);
          return line ? changeLine(line.key, 0) : cart;
        });

    work
      .then(refresh)
      .then(sync)
      .catch(function (err) {
        console.warn('[ct-extras] operatie esuata', err);
        getCart(true).then(sync);
      })
      .then(function () {
        busy = false;
        if (host) host.classList.remove('is-busy');
      });
  }

  /* ---------- interactiuni ---------- */

  /**
   * Orice link catre /cart deschide sertarul, nu pagina - asa se comporta
   * si UpCart inainte. Tema leaga doar iconita cu clasa ei; daca legatura
   * ei nu apuca sa se faca (scriptul temei inca se incarca, sau a picat),
   * linkul ducea clientul pe pagina de cos. Prindem clickul in faza de
   * captura, deschidem sertarul prin tema, iar daca tema nu raspunde in
   * 2,5 secunde lasam navigarea normala.
   */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href !== '/cart' && href.indexOf('/cart?') !== 0 && href.indexOf('/cart#') !== 0) return;
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    var t0 = Date.now();
    (function open() {
      var Cart = window.MinimogTheme && window.MinimogTheme.Cart;
      if (Cart && typeof Cart.openCartDrawer === 'function' && document.querySelector('.scd__wrapper:not(.sf-cart)')) {
        Cart.openCartDrawer();
        return;
      }
      if (Date.now() - t0 > 2500) { window.location.href = href; return; }
      setTimeout(open, 120);
    })();
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var btn = e.target.closest('[data-ct-add]');
    if (!btn || btn.disabled) return;
    var host = btn.closest('[data-ct-upsell]');
    if (!host) return;
    e.preventDefault();
    toggle(host.getAttribute('data-variant'), true, host);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;

    // Bifa de aprobare a costului de procesare
    if (e.target.matches && e.target.matches('[data-ct-fee-ok]')) {
      var on = e.target.checked;
      setFeeAcknowledged(on);
      var fee = e.target.closest('[data-ct-fee]');
      if (fee) {
        fee.classList.toggle('is-ack', on);
        fee.classList.toggle('is-pending', !on);
      }
      var nf = nodes();
      if (nf) gateCheckout(nf);
      return;
    }

    var host = e.target.closest('[data-ct-addon]');
    if (!host) return;
    if (e.target.type !== 'checkbox') return;
    toggle(host.getAttribute('data-variant'), e.target.checked, host);
  });

  // Tema nu emite intotdeauna un eveniment la inchiderea sertarului.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.scd__close') || e.target.closest('.scd__overlay')) {
      document.documentElement.classList.remove('ct-drawer-open');
    }
  });

  // Pe mobil tema nu inchide sertarul la atingere in afara lui.
  ['click', 'touchend'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var wrap = document.querySelector('.scd__wrapper');
      if (!wrap || wrap.classList.contains('hidden')) return;
      if (document.body.classList.contains('template-cart')) return;
      var t = e.target;
      if (t !== wrap && !(t.classList && t.classList.contains('scd__overlay'))) return;
      var Cart = window.MinimogTheme && window.MinimogTheme.Cart;
      if (Cart && Cart.closeCartDrawer) Cart.closeCartDrawer();
      document.documentElement.classList.remove('ct-drawer-open');
    }, { passive: true });
  });

  /* ---------- pornire ---------- */

  var resyncTimer = null;

  function resync() {
    feeFails = 0;
    if (resyncTimer) clearTimeout(resyncTimer);
    resyncTimer = setTimeout(function () {
      resyncTimer = null;
      getCart(true).then(sync);
    }, 250);
  }

  var booted = false;

  function drawerOpen() {
    var wrap = document.querySelector('.scd__wrapper:not(.sf-cart)');
    return !!wrap && !wrap.classList.contains('hidden');
  }

  function boot() {
    if (booted) return;
    booted = true;
    window.ctExtrasReady = true;

    var events = window.MinimogEvents;
    if (events && events.subscribe) {
      events.subscribe('ON_CART_UPDATE', function (cart) {
        if (cart && cart.items) { cartCache = cart; cartCacheAt = Date.now(); sync(cart); }
        else resync();
      });
      events.subscribe('ON_OPEN_DRAWER_CART', function (cart) {
        document.documentElement.classList.add('ct-drawer-open');
        if (cart && cart.items) sync(cart); else resync();
      });
      events.subscribe('ON_CART_CLOSED', function () {
        document.documentElement.classList.remove('ct-drawer-open');
      });
      events.subscribe('ON_ITEM_ADDED', function () { resync(); });
    }

    /*
     * Plasa de siguranta: la fiecare secunda comparam o semnatura a starii,
     * calculata doar din DOM. Daca nimic nu s-a schimbat, nu cerem nimic de
     * la server - deci costul e o comparatie de siruri, nu o cerere de retea.
     */
    var pulseSig = '';
    var pulseTick = 0;
    setInterval(function () {
      var subtotal = document.querySelector('.scd__subtotal-price') || document.querySelector('[data-cart-subtotal-price]');
      var badge = document.querySelector('.sf-cart-count');
      var sig = document.querySelectorAll('.scd-item').length + '|' +
                (drawerOpen() ? '1' : '0') + '|' +
                document.querySelectorAll('[data-ct-extras]').length + '|' +
                (subtotal ? subtotal.textContent : '') + '|' +
                (badge ? badge.textContent : '');
      var schimbat = sig !== pulseSig;
      pulseSig = sig;

      // La fiecare a cincea bataie verificam si cosul de pe server, chiar daca
      // in pagina nu s-a miscat nimic: asa prindem costul scos din alta parte.
      // Doar cand blocul exista in pagina - sertarul Minimog se injecteaza
      // prin AJAX, iar pana atunci nu are rost sa cerem nimic de la server.
      pulseTick++;
      if ((schimbat || pulseTick % 5 === 0) && root()) getCart(true).then(sync);
    }, 1000);

    resync();
  }

  // Pornim pe MinimogEvents, nu pe prezenta blocului: sertarul se injecteaza
  // prin AJAX abia la prima deschidere, deci blocul poate aparea oricand.
  var tries = 0;
  var timer = setInterval(function () {
    var ready = window.MinimogEvents && window.MinimogEvents.subscribe;
    if (ready || ++tries > 300) {
      clearInterval(timer);
      if (ready || root()) boot();
    }
  }, 100);
})();
